import React from 'react'
import { Form, Formik } from 'formik'
import { makeStyles } from '@mui/styles'
import { Grid } from '@mui/material'

import { withModal } from 'utils/providers/ModalProvider'

import { editSocialValidationSchema } from './config'
import modals from 'constants/modals'

import { useAuth } from 'utils/providers/AuthProvider'

import {
  BaseDialog,
  FormikField,
  DialogButtons,
  HelperBlock,
  DiscordIcon,
} from 'shared'

import {
  BaseModalComponentType,
  ModalNameToModalMap,
} from 'components/modals/types'

import { InstagramIcon, TikTokIcon } from 'shared'

const useStyles = makeStyles((theme) => {
  return {
    dialog: {
      '& .base-dialog-header': {
        marginBottom: 12,
        '& h2': {
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '24px',
        },
      },
    },
    subtitle: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '20px',
      marginBottom: '32px',
    },
    iconContainer: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      marginRight: 24,
      padding: '0 20px',
      display: 'flex',
      width: 64,
      height: 64,
    },
  }
})

const EditSocialMediaModal = ({
  isOpen,
  closeModal,
  payload,
}: BaseModalComponentType & {
  payload: ModalNameToModalMap['editSocialMedia']
}) => {
  const classes = useStyles()
  const { user } = useAuth()

  const onSubmit = (values: {
    instagramHandle: string
    tiktokHandle: string
  }) => {
    payload?.onSave(values)
    closeModal()
  }

  const initialValues = {
    instagramHandle: user?.profile?.instagramHandle || '',
    tiktokHandle: user?.profile?.tiktokHandle || '',
  }

  return (
    <BaseDialog
      open={isOpen}
      onClose={closeModal}
      title="Edit social media links"
      className={classes.dialog}
    >
      <Grid sx={{ mb: 2 }}>
        <HelperBlock label="This data will be updated on your profile page." />
      </Grid>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={editSocialValidationSchema}
      >
        {({ dirty }) => {
          return (
            <Form>
              <Grid container flexWrap="nowrap" sx={{ mb: 3 }}>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  className={classes.iconContainer}
                >
                  <InstagramIcon width={24} height={24} />
                </Grid>
                <FormikField
                  name="instagramHandle"
                  label="Instagram handle"
                  placeholder="Enter instagram handle"
                />
              </Grid>
              <Grid container flexWrap="nowrap" sx={{ mb: 3 }}>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  className={classes.iconContainer}
                >
                  <TikTokIcon width={24} height={24} />
                </Grid>
                <FormikField
                  name="tiktokHandle"
                  label="Tiktok handle"
                  placeholder="Enter tiktok handle"
                />
              </Grid>

              <Grid container flexWrap="nowrap">
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  className={classes.iconContainer}
                >
                  <DiscordIcon width={24} height={24} />
                </Grid>
                <FormikField
                  name="discordHandle"
                  label="Discord handle"
                  placeholder="Enter discord handle"
                />
              </Grid>

              <DialogButtons
                onCancel={closeModal}
                submitTitle="Save changes"
                isSubmitDisabled={!dirty}
              />
            </Form>
          )
        }}
      </Formik>
    </BaseDialog>
  )
}

export default withModal(modals.editSocialMedia)(EditSocialMediaModal)
